/* eslint-disable @typescript-eslint/no-empty-function */
import { useEffect, useRef, useState } from "react";
import { Button as Btn, Dialog, DialogActions, DialogContent, DialogTitle, Icon, TextField, Typography as Text } from "@cti-workspace/ui";
import {
  JWT_TOKEN,
  JWT_PUB,
  ALGORITHM,
} from "@cti-workspace/helpers";
import axios from "axios";
import { dateFomat } from "../utils/dateFormat";

import { getObjectValue } from "../utils/commonUtilityFunctions";
import Renderer from "../renderer";
import { useReactToPrint } from "react-to-print";
import { ArrowsInLineVertical, CheckCircle, Warning, XCircle } from "@phosphor-icons/react";
import styled from "styled-components";
import { useSnackbar } from "notistack";
import { ContrastColor, LinkedInButton, PrintButton, ShareButton, VerifyButton } from "./Button";
import { hexToRGB } from "./util";
import jwt from "jsonwebtoken";

import { jsPDF } from "jspdf/dist/jspdf.es.min";
import QRCode from "qrcode.react";

const CertPreviewElement = styled.div`
	height: 65px;
	width: 114px;
	padding: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 8px;
	cursor: pointer;
`;

function CertSelectorPage({ data = {}, certBgImg = {}, badgeUrl = "", setPreviewType = () => { }, previewType = "cert", isSmallDevice = false, fallbackBackgroundImg = null, publicUrl = "" }) {
  const hasPublicUrl = publicUrl && publicUrl !== "" && publicUrl !== "null" && publicUrl !== "undefined";
	return (
    <div style={{ display: "flex", gap: "0.5rem", justifyContent: isSmallDevice ? "center" : "flex-start" }}>
      {certBgImg && (
        <CertPreviewElement style={{ backgroundColor: previewType === "cert" ? "#E0E0E0" : "#FAFAFA" }} onClick={() => setPreviewType("cert")}>
          <img src={certBgImg} style={{ maxHeight: "100%", maxWidth: "100%" }} alt=""
            onError={({ currentTarget }) => {
              if (fallbackBackgroundImg && currentTarget.src !== fallbackBackgroundImg) { // prevent looping
                currentTarget.src = fallbackBackgroundImg;
              }
            }} />
        </CertPreviewElement>
      )}
			{badgeUrl && (
				<CertPreviewElement style={{ backgroundColor: previewType === "badge" ? "#E0E0E0" : "#FAFAFA" }} onClick={() => setPreviewType("badge")}>
          <img src={badgeUrl} style={{ maxHeight: "100%", maxWidth: "100%" }} alt="" />
				</CertPreviewElement>
      )}
      {hasPublicUrl && (
        <QRCode value={publicUrl} size={64} />
      )}
		</div>
	);
}

function CertFabricPageSelector({ fabricPageNames = [], setActivePageName = () => {} }) {
	let style = { minWidth: "200px", height: "46px", borderRadius: "8px", padding: "10px", outline: "grey solid 1px", borderRight: "16px solid transparent", borderColor: "transparent" };
	var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	if (isSafari) {
		// for safari
		style = {
			minWidth: "200px",
			height: "46px",
			borderRadius: "8px",
			padding: "10px",
			borderColor: "grey",
		};
	}
	return (
		<div>
			{fabricPageNames?.length > 1 ? (
				<select
					style={{ ...style }}
					onChange={(e) => {
						console.log(e);
						setActivePageName(e.target.value);
					}}>
					{fabricPageNames
						.filter((item) => item !== "defaultPage")
						.map((value) => (
							<option value={value}>{value}</option>
						))}
				</select>
			) : null}
		</div>
	);
}

const PrintVerifyContainer = styled.div`
	display: flex;
	gap: 1rem;
	width: 100%;
	@media (max-width: 768px) {
		flex-direction: column-reverse;
	}
`;

const HiddenSmallScreen = styled.div`
	@media (max-width: 768px) {
		display: none;
	}
`;

function PrintVerifyButton({ theme, btnStyles = {}, onClickVerify = () => {}, additionalDataMain = {}, handlePrint = () => {}, enableDownload = false, onClickDownload = () => {}, isRevoke = false }) {
	return (
		<PrintVerifyContainer>
			{!additionalDataMain?.settings?.verifierConfiguration?.disablePrint && !enableDownload && (
				<PrintButton theme={theme} onClick={handlePrint} disabled={isRevoke}>
					<>
						<Icon name={"printer"} size={23} weight={"fill"} color={hexToRGB(theme.primaryColor, theme.primaryColorOpacity)} />
						<span style={{ fontSize: "1.125rem", fontWeight: "700" }}>Print Certificate</span>
					</>
				</PrintButton>
			)}
			{enableDownload && (
				<PrintButton theme={theme} onClick={onClickDownload} disabled={isRevoke}>
					<>
						<Icon name={"download"} size={23} weight={"fill"} color={hexToRGB(theme.primaryColor, theme.primaryColorOpacity)} />
						<span style={{ fontSize: "1.125rem", fontWeight: "700" }}>Download</span>
					</>
				</PrintButton>
			)}
			<VerifyButton theme={theme} onClick={onClickVerify}>
				<>
					<Icon name={"checkcircle"} size={23} weight={"fill"} color={ContrastColor(theme.primaryColor)} />
					<span style={{ fontSize: "1.125rem", fontWeight: "700" }}>Verify</span>
				</>
			</VerifyButton>
			{/* <TempButton>Verify</TempButton> */}

			{/* <Btn {...btnStyles} leftIcon="checkcircle" leftIconSize="23" leftIconWeight="fill" onClick={onClickVerify} bgColor={"#fff"} disableTheme></Btn> */}
		</PrintVerifyContainer>
	);
}

function CertButtons({
	onClickVerify = () => {},
	onClickEmail = () => {},
	onClickLinkedIn = () => {},
	onClickTwitter = () => {},
	onClickDownload = () => {},
	onClickLink = () => {},
	onClickAddToLinkedInProfile = () => {},
	additionalDataMain = {},
	handlePrint = () => {},
	enableDownload = false,
	theme,
  isRevoke = false,
  rest = {},
}) {
	const btnStyles = {
		style: {
			width: "100%",
		},
		buttonStyle: {
			fontSize: "1.1rem",
			borderWidth: "1px",
			padding: "0.5rem",
		},
		borderRadius: "8px",
		color: "warning",
  };

  const pub = JWT_PUB.replace(/\\n/g, "\n");
  const algorithms = [ALGORITHM];


  let jwtToken = localStorage.getItem(JWT_TOKEN);

  try {
    let account = jwt.verify(jwtToken, pub, { algorithms });
    // console.log(account);
    if (account == null || account.lastName || rest == null || rest.parsedDoc == null || rest.parsedDoc == null || rest.parsedDoc.credentialSubject == null || rest.parsedDoc.credentialSubject.name == null
      || rest.parsedDoc.credentialSubject.name.Includes(account.lastName) === false) {
      jwtToken = null;
    }
  } catch (err) {
    jwtToken = null;
  }

  if (jwtToken) {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem", width: "100%" }}>
        <PrintVerifyButton theme={theme} enableDownload={enableDownload} btnStyles={btnStyles} onClickVerify={onClickVerify} additionalDataMain={additionalDataMain} handlePrint={handlePrint} onClickDownload={onClickDownload} isRevoke={isRevoke} />
        <HiddenSmallScreen>
          <Text type="body2" fontWeight="700" textAlign="center">
            Share this credential
          </Text>
        </HiddenSmallScreen>
        <ShareIcons theme={theme} onClickEmail={onClickEmail} onClickLinkedIn={onClickLinkedIn} onClickTwitter={onClickTwitter} onClickDownload={onClickDownload} onClickLink={onClickLink} isRevoke={isRevoke} rest={rest} />
        {!additionalDataMain?.settings?.verifierConfiguration?.disableAddToLinkedin && (
          <LinkedInButton onClick={onClickAddToLinkedInProfile} disabled={isRevoke}>
            <>
              <Icon name={"linkedin"} size={30} weight={"fill"} color={"white"} />
              <span style={{ fontSize: "1.125rem", fontWeight: "700" }}>Add to my LinkedIn profile</span>
            </>
          </LinkedInButton>
        )}
      </div>
    );
  } else {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem", width: "100%" }}>
        <PrintVerifyButton theme={theme} enableDownload={enableDownload} btnStyles={btnStyles} onClickVerify={onClickVerify} additionalDataMain={additionalDataMain} handlePrint={handlePrint} onClickDownload={onClickDownload} isRevoke={isRevoke} />
      </div>
    );
  }
}

function ShareIcons({ theme, onClickLinkedIn = () => { }, onClickTwitter = () => { }, onClickDownload = () => { }, onClickLink = () => { }, isRevoke = false, rest = {} }) {
	// const btnStyles = {
	// 	buttonType: "icon",
	// 	invert: true,
	// 	buttonTransparent: true,
	// 	buttonHover: true,
	// 	style: {
	// 		width: "100%",
	// 	},
	// 	buttonStyle: {
	// 		padding: "0.6rem",
	// 		border: "1px solid #E0E0E0",
	// 		borderRadius: "8px",
	// 		width: "100%",
	// 		justifyContent: "center",
	// 	},
	// 	iconSize: 27,
	// 	iconWeight: "fill",
	// };
	// let val = ContrastColor("#0072b1");
	// console.log(val);
  const linkedInEnabled = rest?.additionalDataMain?.shortURLs?.postOnLinkedinUrl ? true : false;
  const twitterEnabled = rest?.additionalDataMain?.shortURLs?.postOnTwitterUrl ? true : false;
  const shareEnabled = rest?.additionalDataMain?.shortURLs?.publicUrl ? true : false;

	return (
		<div style={{ display: "flex", gap: "1rem", width: "100%", justifyContent: "space-between" }}>
      <ShareButton theme={theme} icon="linkedin" onClick={onClickLinkedIn} iconColor={"#0072B1"} toolTipText={"Share in a post on LinkedIn"} disabled={isRevoke || !linkedInEnabled} />
      <ShareButton theme={theme} icon="twitter" onClick={onClickTwitter} iconColor={"#00ACEEDE"} toolTipText={"Share on X"} disabled={isRevoke || !twitterEnabled} />
      <ShareButton theme={theme} icon="link" onClick={onClickLink} iconColor={theme.primaryColor} toolTipText={"Copy the link to your credential"} disabled={!shareEnabled}  />
			{/* <ShareButton theme={theme} icon="envelope" onClick={onClickEmail} iconColor={theme.primaryColor} /> */}
			{/* <Btn icon="envelope" color="warning" {...btnStyles} /> */}
			{/* <Btn color="warning" {...btnStyles} buttonStyle={{ ...btnStyles.buttonStyle, color:  }} onClick={onClickLinkedIn} />
			<Btn color="warning" {...btnStyles} buttonStyle={{ ...btnStyles.buttonStyle, color: }} onClick={onClickTwitter} /> */}
			{/* <Btn icon="download" color="warning" {...btnStyles} disabled={!enableDownload} onClick={onClickDownload} /> */}
		</div>
	);
}

function VerifyLabelValueRow({ label = "", value = "", valid = true }) {
	return (
		<div style={{ display: "flex", justifyContent: "space-between" }}>
			<div>
				<Text type="body2" fontWeight="600">
					{label}
				</Text>
				<Text type="body3" color={"text"}>
					{value}
				</Text>
			</div>
			<div style={{ height: "40px", width: "40px", backgroundColor: "#FAFAFA", padding: "0.1rem", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
				{valid ? <CheckCircle size={25} weight="fill" color="#14C25A" /> : <XCircle size={25} weight="fill" color="#FF3D33" />}
			</div>
		</div>
	);
}

function VerificationMethodKeyValue({ label = "", value = "" }) {
	return (
		<div style={{ display: "flex", flexDirection: "column", wordBreak: "break-all" }}>
			<Text type="body6" fontWeight="700" color="text" style={{ textTransform: "uppercase" }}>
				{label}
			</Text>
			<Text type="body6" color="text">
				{value}
			</Text>
		</div>
	);
}

const MainContent = ({ ...rest }) => {
  const [verifyState, setVerifyState] = useState(false);
	const [emailState, setEmailState] = useState(false);
	const [verificationMethodExpand, setVerificationMethodExpand] = useState(false);
	const [showBadge, setShowbadge] = useState(false);
	const [isDraft, setIsDraft] = useState(false);
	const [creExpiredText, setCreExpiredText] = useState("");
	const [certBgImg, setCertBgImg] = useState("");
	const [previewType, setPreviewType] = useState("cert");
	const [fabricPageNames, setFabricPageNames] = useState([]);
	const [activePageName, setActivePageName] = useState(null);
	const [printPageSize, setPrintPageSize] = useState({ type: "", size: "landscape", pageType: "A4" });
	const { name, credentialSubject, issuer, additionalData, proof: parsedDocProof = {} } = getObjectValue(rest, "parsedDoc", {});
  const { proof = {} } = rest?.requestedDoc || {};

  const onClickVerify = () => {
		setVerifyState(true);
	};

	useEffect(() => {
		if (rest.usedNewApi && rest.renderConfig) {
			const { renderConfig } = rest;
			if (renderConfig.data) {
				if (renderConfig?.data?.type !== "fabricDesign") {
					setIsDraft(true);
          const { style } = renderConfig ? renderConfig.data : false;
					if (style) {
						const { backgroundImage } = JSON.parse(style);
						const bgUrl = /(?:\(['"]?)(.*?)(?:['"]?\))/.exec(backgroundImage)[1];
						setCertBgImg(bgUrl);
					}
				}
			}
		}
	}, [rest]);

	const onClickEmail = () => {
		setEmailState(true);
	};

	const onClickLinkedIn = () => (rest?.additionalDataMain?.shortURLs?.postOnLinkedinUrl ? window.open(rest.additionalDataMain.shortURLs.postOnLinkedinUrl, "_blank") : null);
	const onClickTwitter = () => (rest?.additionalDataMain?.shortURLs?.postOnTwitterUrl ? window.open(rest.additionalDataMain.shortURLs.postOnTwitterUrl, "_blank") : null);

	const onClickDownload = async () => {
		if (rest?.parsedDoc?.additionalData?.imageUrl) {
			try {
				const originalImage = rest?.parsedDoc?.additionalData?.imageUrl;
				const { data } = await axios.get(originalImage + `?timestamp=${new Date()}`, {
					headers: {
						"Content-Type": "application/octet-stream",
					},
					responseType: "blob",
					withCredentials: false,
				});
				const a = document.createElement("a");
				const url = window.URL.createObjectURL(data);
				a.href = url;
				const fileExt = originalImage.split(".").pop();
				const fileName = name?.toLowerCase()?.substring(0, 150).split(" ").join("-");
				a.download = fileName + "." + fileExt;
				a.click();
			} catch (error) {
				console.error("error", error);
				try {
					let imageURL = rest?.parsedDoc?.additionalData?.imageUrl;
					const downloadedImg = document.createElement("img");
					downloadedImg.crossOrigin = "anonymous";
					downloadedImg.src = imageURL + `?timestamp=${new Date()}`;
					console.log(downloadedImg);
					downloadedImg.onload = () => {
						const canvas = document.createElement("canvas");
						const context = canvas.getContext("2d");
						canvas.width = downloadedImg.width;
						canvas.height = downloadedImg.height;
						canvas.innerText = downloadedImg.alt;
						context.drawImage(downloadedImg, 0, 0);
						try {
							const a = document.createElement("a");
							a.href = canvas.toDataURL("image/png");
							const fileExt = imageURL.split(".").pop();
							const fileName = name?.toLowerCase()?.substring(0, 150).split(" ").join("-");
							a.download = fileName + "." + fileExt;
							a.click();
						} catch (err) {
							console.error(`Error: ${err}`);
						}
					};
				} catch (error1) {
					console.error("error1", error1);
				}
			}
		}
	};

	const { enqueueSnackbar } = useSnackbar();

	const onClickLink = () => {
		function getCurrentURL() {
			return window.location.href;
		}
		const url = getCurrentURL();
		try {
			if (rest?.whitelabel?.buttonConfig?.copyURL?.useShortURL) {
				navigator.clipboard.writeText(rest.additionalDataMain.shortURLs.publicUrl);
			} else {
				navigator.clipboard.writeText(url);
			}

			enqueueSnackbar("Link has been copied to the clipboard", {
				variant: "success",
			});
		} catch (error) {
			enqueueSnackbar("Link not copied", {
				variant: "error",
			});
		}
	};
	// this needs to copy to clip board and show alert
	const onClickAddToLinkedInProfile = () => window.open(rest.additionalDataMain.shortURLs.addToLinkedinUrl, "_blank");

	const badgeUrl = useRef();

	const locale = rest?.additionalDataMain?.settings?.verifierConfiguration?.locale;

	const getBadgeUrl = (url) => {
		badgeUrl.current = url;
	};

	const componentRef = useRef(null);
	const fabricCertiFullPageRef = useRef(null);
	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
  });

  const verificationStatus = (type) => {
    if (rest === null || rest.verification === null || rest.verification.results === null ) {
      return true;
    }
    for (var ii = 0; ii < rest.verification.results.length; ii++) {
      if (rest.verification.results[ii].type === type) {
        return rest.verification.results[ii].status !== 'INVALID';
      }
    }

    return true;
  };

  const isCertValid = verificationStatus('DOCUMENT_STATUS') && verificationStatus('DOCUMENT_INTEGRITY');

	const downloadPdf = () => {
		try {
			const { pageType, size } = rest.printPageSize;
			const {
				parsedDoc: { name },
			} = rest;
			const A4 = [595.28, 841.89];
			const Letter = [612.0, 792.0];
			let pageWidth, pageHeight;
			if (pageType === "A4") {
				pageWidth = size === "landscape" ? A4[1] : A4[0];
				pageHeight = size === "landscape" ? A4[0] : A4[1];
			} else if (pageType === "letter") {
				pageWidth = size === "landscape" ? Letter[1] : Letter[0];
				pageHeight = size === "landscape" ? Letter[0] : Letter[1];
			}

			const doc = new jsPDF({
				orientation: size,
				unit: "mm",
				format: [pageWidth, pageHeight],
			});

			doc.addImage({
				imageData: fabricCertiFullPageRef?.current?.toDataURL("image/png"),
				x: 0,
				y: 0,
				width: pageWidth,
				height: pageHeight,
			});
			doc.save(`${name}.pdf`);
		} catch (err) {
			console.error(err);
			enqueueSnackbar("WARNING: Due to some internal issue we are not able process your request. please contact support.", { variant: "warning" });
		}
	};
	// const handleIframePrint = () => {
	// 	componentRef.current({
	// 		type: "PRINT",
	// 	});
	// };

	useEffect(() => {
		// console.log("test", rest.parsedDoc);
		const { expirationDate } = rest.parsedDoc;
		if (expirationDate) {
			if (rest.creExpired) {
				const val = `This credential has expired on ${dateFomat({ date: expirationDate, locale })}`;
				setCreExpiredText(val);
			}
		}
  }, [rest?.parsedDoc, rest?.creExpired, locale]);

  var badgeImgUrl = rest?.parsedDoc?.additionalData?.imageUrl;

  if (badgeImgUrl && badgeImgUrl.includes("ca-central") ) {
    badgeImgUrl = null;
  }
	return (
		<>
			<div style={{ width: "100%" }}>
				<div style={{ marginBottom: rest.isSmallDevice ? "1rem" : "0px" }}>
					<div style={{ display: "flex", justifyContent: rest.isSmallDevice ? "center" : "space-between", alignItems: "flex-end" }}>
            {!rest.isSmallDevice ? <CertSelectorPage data={rest?.parsedDoc} badgeUrl={badgeImgUrl} certBgImg={certBgImg} setPreviewType={setPreviewType} previewType={previewType} fallbackBackgroundImg={rest?.fallbackBackgroundImg} publicUrl={rest?.additionalDataMain?.shortURLs?.publicUrl} /> : null}
						<CertFabricPageSelector fabricPageNames={fabricPageNames} setActivePageName={setActivePageName} />
					</div>
					<div style={{ display: isDraft ? "block" : "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
						{previewType === "cert" ? (
							<Renderer
								getBadgeUrl={getBadgeUrl}
								showBadge={showBadge}
								locale={locale}
								setIsDraft={setIsDraft}
								componentRef={componentRef}
								creExpiredText={creExpiredText}
								setPrintPageSize={setPrintPageSize}
								setCertBgImg={setCertBgImg}
								setFabricPageNames={setFabricPageNames}
								activePageName={activePageName}
								fabricCertiFullPageRef={fabricCertiFullPageRef}
                downloadPdf={downloadPdf}
                isCertValid={isCertValid}
								{...rest}
							/>
						) : (
							<div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", padding: "2rem" }}>
								<img src={rest?.parsedDoc?.additionalData?.imageUrl} style={{ maxHeight: "20rem", maxWidth: "40rem" }} alt=""/>
							</div>
						)}
					</div>
					{rest.isSmallDevice ? (
            <CertSelectorPage data={rest?.parsedDoc} badgeUrl={rest?.parsedDoc?.additionalData?.imageUrl} certBgImg={certBgImg} setPreviewType={setPreviewType} previewType={previewType} isSmallDevice={rest?.isSmallDevice} fallbackBackgroundImg={rest?.fallbackBackgroundImg} publicUrl={rest?.additionalDataMain?.shortURLs?.publicUrl} />
					) : null}
				</div>
				<CertButtons
					onClickVerify={onClickVerify}
					onClickEmail={onClickEmail}
					onClickLinkedIn={onClickLinkedIn}
					onClickTwitter={onClickTwitter}
					onClickDownload={onClickDownload}
					onClickLink={onClickLink}
					onClickAddToLinkedInProfile={onClickAddToLinkedInProfile}
					additionalDataMain={rest?.additionalDataMain}
					handlePrint={handlePrint}
					enableDownload={previewType === "badge" ? true : false}
					theme={rest.theme}
          isRevoke={rest?.certState === "revoked" ? true : false || rest?.creExpired || isCertValid === false}
          rest={rest}
				/>
			</div>
			{/* verify */}
			{verifyState && (
				<Dialog open maxWidth="sm" borderRadius="8px">
					<DialogTitle style={{ padding: "0.5rem", borderBottom: "none" }}>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", ...(rest?.certState === "revoked" || isCertValid === false ? { backgroundColor: "#FF3D33", borderRadius: "8px", padding: "0.1rem", paddingRight: "0.3rem" } : {}) }}>
							{rest?.certState === "revoked" && (
								<div style={{ display: "flex", gap: "0.1rem", alignItems: "center", justifyContent: "center", width: "100%" }}>
									<Warning weight="fill" color="white" />
									<Text type="body1" fontWeight="700" color="white" style={{ margin: "0.3rem" }}>
										The credential has been revoked
									</Text>
								</div>
              )}
              {isCertValid === false && rest?.certState !== "revoked" && (
                <div style={{ display: "flex", gap: "0.1rem", alignItems: "center", justifyContent: "center", width: "100%" }}>
                  <Warning weight="fill" color="white" />
                  <Text type="body1" fontWeight="700" color="white" style={{ margin: "0.3rem" }}>
                    The credential has been tampered with
                  </Text>
                </div>
              )}
							<Btn buttonType="icon" icon="cancel" color="primary" iconSize="0.9rem" invert onClick={() => setVerifyState(false)} />
						</div>
						<div style={{ display: "flex", gap: "1rem", width: "100%", padding: "0.5rem 1.5rem" }}>
							<div style={{ flex: 1 }}>
								<Text type="body1" fontWeight="700">
									{name}
								</Text>
								<Text type="body3" style={{ marginTop: "0.5rem", color: "#324353" }}>
									This {name} credential has been{" "}
									<Text type="body3" style={{ display: "inline", color: rest?.certState === "revoked" || rest?.creExpired ? "#FF3D33" : rest.theme.primaryColor }}>
                    {rest?.certState === "revoked" ? "revoked" : rest?.creExpired ? "expired" : isCertValid ? "verified" : "reviewed"}
									</Text>
									. This digital credential was securely issued via{" "}
									<Text type="body3" style={{ display: "inline", color: rest.theme.primaryColor }}>
										{getObjectValue(issuer, "name")}
                  </Text>
                  {isCertValid ? " and its information is valid." : " but now has failed validation."}									
								</Text>
							</div>
							<div style={{ height: "40px", width: "40px", backgroundColor: "#FAFAFA", padding: "0.1rem", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
								<img src={getObjectValue(additionalData, "imageUrl")} style={{ maxWidth: "100%", maxHeight: "100%" }} alt="" />
							</div>
						</div>
						<div style={{ margin: "0.5rem 1.5rem", borderBottom: "1px solid #E0E0E0" }} />
					</DialogTitle>
					<DialogContent style={{ border: "0px", padding: "0rem 2rem", paddingBottom: "2rem" }}>
						<div style={{ display: "grid", gap: "0.5rem" }}>
							<VerifyLabelValueRow label="Verified Owner" value={getObjectValue(credentialSubject, "name")} />
              <VerifyLabelValueRow label="Verified Issuer" value={getObjectValue(issuer, "name")} />
              <VerifyLabelValueRow label="Credential" value={`Has${verificationStatus('DOCUMENT_INTEGRITY') ? " not" : ""} been altered`} valid={verificationStatus('DOCUMENT_INTEGRITY')} />
              <VerifyLabelValueRow label="Signature" value={verificationStatus('DOCUMENT_STATUS') ? "Valid" : "Invalid"} valid={verificationStatus('DOCUMENT_STATUS')} />
							<VerifyLabelValueRow label="Domain Ownership Verified" value={getObjectValue(issuer, "url")} />
							<VerifyLabelValueRow
								label="Credential"
								value={`Has ${rest?.certState === "revoked" || rest?.creExpired ? "" : "not"} been ${rest?.creExpired ? "expired" : "revoked"}`}
								valid={rest?.certState === "revoked" || rest?.creExpired ? false : true}
							/>
						</div>
						<div style={{ marginTop: "1rem", borderBottom: "1px solid #E0E0E0", marginBottom: "1rem" }} />
						<Text type="body1" fontWeight="600">
							Verification Method
						</Text>
						<Text type="body3">This credential was cryptographically signed</Text>
						<div style={{ backgroundColor: "#FAFAFA", padding: "0.5rem", display: "flex", justifyContent: "space-between", borderRadius: "8px" }}>
							<div style={{ flex: 1, width: "100%" }}>
								<VerificationMethodKeyValue label="Type:" value={getObjectValue(parsedDocProof, "type")} />
								{verificationMethodExpand && (
									<>
										<VerificationMethodKeyValue label="CREATED:" value={getObjectValue(parsedDocProof, "created")} />
										<VerificationMethodKeyValue label="PROOF PURPOSE:" value={getObjectValue(parsedDocProof, "proofPurpose")} />
										<VerificationMethodKeyValue label="VERIFICATION METHOD:" value={getObjectValue(parsedDocProof, "verificationMethod")} />
										<VerificationMethodKeyValue label="SIGNATURE:" value={getObjectValue(proof, "signature")} />
									</>
								)}
							</div>
							<div style={{ marginTop: "0.3rem", cursor: "pointer", marginRight: "0.5rem" }} onClick={() => setVerificationMethodExpand((prevState) => !prevState)}>
								<ArrowsInLineVertical size={15} weight="fill" color="rgba(0,0,0,0.87)" />
							</div>
						</div>
					</DialogContent>
				</Dialog>
			)}
			{emailState && (
				<Dialog open maxWidth="sm" borderRadius="8px">
					<DialogTitle style={{ padding: "0.5rem", borderBottom: "none" }}>
						<div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
							<Btn buttonType="icon" icon="cancel" color="primary" iconSize="0.9rem" invert onClick={() => setEmailState(false)} />
						</div>
						<span style={{ padding: "0.5rem 1.5rem" }}>Share this Credential by Email</span>
					</DialogTitle>
					<DialogContent style={{ border: "0px", padding: "0rem 2rem", paddingBottom: "2rem" }}>
						<Text type="body2">Input the desired email. For multiple emails, separate the emails with commas.</Text>
						<TextField size="small" style={{ marginTop: "0.5rem" }} />
					</DialogContent>
					<DialogActions>
						<Btn color="primary" invert onClick={() => setEmailState(false)}>
							Cancel
						</Btn>
						<Btn color="warning">Send Credential</Btn>
					</DialogActions>
				</Dialog>
			)}
		</>
	);
};

export default MainContent;
